import { ReactNode } from 'react';
import { PageShell } from '../../components/DataTablePanel';
import { cn } from '../../lib/utils';

/** Shared scroll shell for myDATA pages — extra right padding for scrollbar/gutter. */
export function MydataPageShell({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <PageShell
      className={cn(
        'overflow-y-auto overscroll-contain scrollbar-thin pr-2 sm:pr-3',
        '[scrollbar-gutter:stable]',
        className,
      )}
    >
      {children}
    </PageShell>
  );
}
